import getEnvironment from "../getEnvironment";

export interface RequestDeliveryParams {
  vehicleIdentifier: string | string[];
  saleCode: string | string[];
}

const buildRequestDeliveryLinkUrl = (
  queryParams: RequestDeliveryParams,
  isExport: boolean = false
) => {
  const environment = getEnvironment();
  const isProd = environment === "production";
  const buyerAPIDomain = isProd
    ? "https://www.bca.co.uk/mybca"
    : "https://cms.uat.britishcarauctions.net/mybca";
  const url = new URL(
    `${buyerAPIDomain}/deliveries/request-delivery${isExport ? "-export" : ""}`
  );

  Object.keys(queryParams).forEach((queryParamKey) => {
    const queryParamValue = queryParams[queryParamKey];
    const value = Array.isArray(queryParamValue)
      ? queryParamValue.join(",")
      : queryParamValue;

    url.searchParams.set(queryParamKey, value);
  });

  return url.href;
};

export default buildRequestDeliveryLinkUrl;
